module.exports = __webpack_public_path__ + "img/yiyongtuire.5b16c26e.jpg";